/* eslint-disable @typescript-eslint/naming-convention */
// istanbul ignore file
import { useRouter } from "next/router";
import { useAnalytics } from "~/components/Analytics";
import { LeadGenerationForm } from "~/components/LandingPageV2/components/LeadGenerationForm";
import { LeadGenerationFormBlock as LeadGenerationFormBlockType } from "~/components/LandingPageV2/schemas";
import { useToastManager } from "~/components/ToastManager";
import { requestDemo } from "~/lib/client/endilApiCalls";
import { RequestDemoFormSchema } from "~/lib/shared/schemas/requestDemoSchema";

export type LeadGenerationFormBlockProps = LeadGenerationFormBlockType;
export const LeadGenerationFormBlock: React.FC<
  LeadGenerationFormBlockProps
> = ({
  eventName,
  openQuestion,
  openQuestionCharacterLimit,
  salesforceCampaignId,
  successMessage,
  successRedirectUrl,
  enableDarkMode,
}) => {
  const { analyticsEnhancedTrack } = useAnalytics();
  const { addToast } = useToastManager();
  const { asPath, push, query } = useRouter();

  const {
    campaignId,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
    utm_content,
  } = query;

  const onFormSubmit = async (values: RequestDemoFormSchema) => {
    analyticsEnhancedTrack(eventName);

    await requestDemo({
      ...values,
      eventName,
      pageUrl: asPath.split("?")[0],
      iterableCampaignId: campaignId,
      utmSource: utm_source,
      utmMedium: utm_medium,
      utmCampaign: utm_campaign,
      utmTerm: utm_term,
      utmContent: utm_content,
    });

    addToast("success", successMessage);

    push(successRedirectUrl.url);
  };

  return (
    <div>
      <LeadGenerationForm
        ctaText="Submit"
        className="order-3 lg:order-2"
        enableDarkMode={enableDarkMode}
        onFormSubmit={onFormSubmit}
        openQuestion={openQuestion}
        openQuestionCharacterLimit={openQuestionCharacterLimit}
        salesforceCampaignId={salesforceCampaignId}
      />
    </div>
  );
};
